import { render, staticRenderFns } from "./FestivalSummer.vue?vue&type=template&id=65921a96&scoped=true"
import script from "./FestivalSummer.vue?vue&type=script&lang=js"
export * from "./FestivalSummer.vue?vue&type=script&lang=js"
import style0 from "./FestivalSummer.vue?vue&type=style&index=0&id=65921a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65921a96",
  null
  
)

export default component.exports